import { Grid, Button, Box, Alert, CircularProgress } from '@mui/material';

import { FormInputDate } from '../forms/formInputs';
import { CNPJAutocomplete } from "../autocompletes"
import { TitlePaper } from '../default';
import { formatCNPJ } from '../../utils';


export default function DashboardFilter({
    currentData,
    filteredCNPJ,
    uniqueDocuments,
    scoreMetrics,
    scoreMetricsByDate,
    onClearFilter,
    onFilterSubmit,
    control,
    errors,
    currentStartDate,
    currentEndDate,
    isFiltered,
    register,
    watch,
    setValue
}) {

    return (
        <TitlePaper
            title="Pesquisar clientes"
            subtitle="Busque pelo CNPJ ou selecione um período para consultar o score."
        >

            {isFiltered && (
                <Alert severity="info" sx={{ mb: 2 }}>
                    Exibindo resultados filtrados para o CNPJ: {formatCNPJ(filteredCNPJ)}
                </Alert>
            )}

            {!isFiltered && !scoreMetrics.loading && currentData.total_queries > 0 && (
                <Alert severity="success" sx={{ mb: 2 }}>
                    Exibindo todos os dados disponíveis ({currentData.total_queries} consultas)
                </Alert>
            )}

            {scoreMetrics.error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    Erro ao carregar dados: {scoreMetrics.error.message || scoreMetrics.error}
                </Alert>
            )}

            {uniqueDocuments.error && (
                <Alert severity="warning" sx={{ mb: 2 }}>
                    Erro ao carregar CNPJs: {uniqueDocuments.error.message || uniqueDocuments.error}
                </Alert>
            )}

            {scoreMetricsByDate.error && (
                <Alert severity="warning" sx={{ mb: 2 }}>
                    Erro ao carregar dados históricos: {scoreMetricsByDate.error.message || scoreMetricsByDate.error}
                </Alert>
            )}

            <Box component="form" onSubmit={onFilterSubmit}>
                <Grid container spacing={2} alignItems="center">

                    <Grid item xs={12} md={6} lg={3}>
                        <CNPJAutocomplete
                            label="Buscar por CNPJ"
                            fullWidth
                            placeholder="00.000.000/0000-00"
                            value={watch('cnpjSearch') || null}
                            name={register('cnpjSearch').name}
                            onChange={(_, newValue) => {
                                setValue('cnpjSearch', newValue)
                            }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={3}>
                        <FormInputDate
                            name="periodStart"
                            label="Data de início"
                            control={control}
                            errors={errors.periodStart}
                            textFieldProps={{
                                fullWidth: true,
                            }}
                            maxDate={currentEndDate}
                            disableFuture
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={3}>
                        <FormInputDate
                            name="periodEnd"
                            label="Data final"
                            control={control}
                            errors={errors.periodEnd}
                            textFieldProps={{
                                fullWidth: true,
                            }}
                            minDate={currentStartDate}
                            disableFuture
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={3}>
                        <Box sx={{ display: 'flex', gap: 1 }}>

                            <Button
                                variant="contained"
                                type="submit"
                                disabled={scoreMetrics.loading || scoreMetricsByDate.loading}
                                sx={(theme) => ({
                                    textTransform: 'none',
                                    [theme.breakpoints.down("lg")]: {
                                        width: "100%"
                                    },
                                    [theme.breakpoints.up("lg")]: {
                                        flex: 1,
                                    }
                                })}
                            >
                                {(scoreMetrics.loading || scoreMetricsByDate.loading) ? (
                                    <CircularProgress size={20} color="inherit" />
                                ) : (
                                    'APLICAR FILTRO'
                                )}
                            </Button>

                            <Button
                                variant="outlined"
                                onClick={onClearFilter}
                                disabled={scoreMetrics.loading || scoreMetricsByDate.loading}
                                sx={(theme) => ({
                                    textTransform: 'none',
                                    [theme.breakpoints.down("lg")]: {
                                        width: "100%"
                                    },
                                })}
                                title="Limpar filtros e mostrar todos os dados"
                            >
                                LIMPAR
                            </Button>

                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </TitlePaper>
    )
}

